module.exports = __webpack_public_path__ + "img/20.3a11ef69.jpg";